import styled from 'styled-components';

export const Container = styled.aside`
  font-family: inherit !important;
`;
